<template>
  <el-tabs v-model="echoParams.activeName" @tab-click="orderSummary">
    <el-tab-pane
      v-for="(item, index) of signContractTabsList"
      :label="`${item.label}(${item.number})`"
      :name="item.name"
      :key="index"
    >
      <!-- eslint-disable-next-line vue/no-unused-refs -->
      <component ref="component"
        @getSummary="orderSummary"
        v-if="echoParams.activeName === item.name"
        :echoParams="echoParams"
        :summaryList="summaryList"
        :is="item.components"
      />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { TabListSeven, getLeaseOrderSummary } from '@/api/domain/orders'
import config from './config'

export default {
  data() {
    const {
      // tab列表
      c_signContractTabsList,
    } = config.call(this)
    return {
      c_signContractTabsList,
      summaryList: {},
      echoParams: {
        activeName: '',
        childActiveName: '1',
      },
    }
  },
  computed: {
    signContractTabsList() {
      return this.c_signContractTabsList.filter((item) => {
        return this.judgePermission(item.resourcesKey)
      })
    },
  },
  mounted() {
    // 处理路由参数
    this.getRouteQuery()
  },
  methods: {
    getRouteQuery() {
      const { activeName, childActiveName, entRentOrderId, deptId } = this.$route.query
      this.echoParams.activeName = activeName || 'personal'
      this.echoParams.childActiveName = childActiveName || '1'
      this.echoParams.entRentOrderId = entRentOrderId || ''
      this.echoParams.deptId = deptId || ''
      // tab统计
      this.orderSummary({ name: activeName, childActiveName, entRentOrderId, deptId })
    },
    // tabs统计
    orderSummary(tab) {
      const { name = 'personal', childActiveName, entRentOrderId, deptId } = tab || {}
      this.echoParams = {
        activeName: name,
        childActiveName: childActiveName || '1',
        entRentOrderId: entRentOrderId || '',
        deptId: deptId || '',
      }
      TabListSeven({
        bizType: 10, // 订单业务类型 10 个人订单 20 企业子订单'
        relatedType: 10, // 合同关联原因 1合同临时换车/2合同换车/3合同换人/4合同续约/5司机模式转租赁模式/10无关联订单
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          name === 'personal' && (this.summaryList = data)
          const { toProcessOrderNum } = data
          this.c_signContractTabsList.forEach((item) => {
            if (item.name === 'personal') {
              item.number = toProcessOrderNum
            }
          })
        }
      })
      TabListSeven({
        bizType: 20, // 订单业务类型 10 个人订单 20 企业子订单'
        relatedType: 10, // 合同关联原因 1合同临时换车/2合同换车/3合同换人/4合同续约/5司机模式转租赁模式/10无关联订单
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          name === 'child' && (this.summaryList = data)
          const { toProcessOrderNum } = data
          this.c_signContractTabsList.forEach((item) => {
            if (item.name === 'child') {
              item.number = toProcessOrderNum
            }
          })
        }
      })
      getLeaseOrderSummary({
        stateList: [1, 2], // 主订单状态列表 1已创建/2进行中/3已关闭
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          const { allOrderNum } = data
          this.c_signContractTabsList.forEach((item) => {
            if (item.name === 'primary') {
              item.number = allOrderNum
            }
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-table__body-wrapper {
  scrollbar-width: thin;
  -ms-overflow-style: thin;
  &::-webkit-scrollbar {
    display: thin;
  }
}
</style>
